<template>
  <v-container>
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('alertEmail')|capitalize }}</span>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field v-model="email_input" :label="$t('alertEmailDescription')|capitalize" :rules="[is_valid_email]"
                          @keydown.enter="validateAndSaveEmail" outlined ref="emailInput">
              <template v-slot:append>
                <v-btn color="primary" @click="validateAndSaveEmail">{{ $t('save') }}</v-btn>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-chip v-for="(email, index) in alert_emails" :key="index"
                    @input="remove_email(index)">
              {{ email }}
              <div class="v-chip__close"><i aria-hidden="true" class="v-icon mdi mdi-close-circle theme--light"
                                            @click="remove_email(index)"></i></div>
            </v-chip>
          </v-flex>
        </v-layout>
      </v-card-text>
      <div class="chat_view_loading" v-if="loadingDialog">
        <div class="loading_overlay"></div>
        <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
      </div>
    </v-card>
  </v-container>
</template>

<style>

.chat_view_loading {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 99999;
  align-items: center;
  text-align: center;
  padding-bottom: 10px;
  padding-top: 30px;

  .loading_overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: black;
    opacity: 0.2;
  }
}
</style>

<script>
import BotService from "@/services/bot.service";
import {mapMutations, mapState} from "vuex";
import {consoleError} from "vuetify/es5/util/console";

export default {
  name: "AlertEmailSetting",
  props: {
    botCode: String
  },
  computed: {
    ...mapState('config', ['botConfig']),
    alert_emails() {
      return this.botConfig['livesupportAlertEmails']
    }
  },
  data() {
    return {
      loadingDialog: false,
      email_input: '',
    }
  },
  mounted() {
  },
  methods: {
    ...mapMutations('config', ['setBotConfig']),
    validateAndSaveEmail() {
      let email = this.email_input;
      if (!email) return;
      if (this.$refs.emailInput.validate()) {
      let emails = [...this.alert_emails];
        if (!emails.includes(email)) {
          emails.push(email);
        }
        this.email_input = '';
        this.save_config(emails);
      }
    },
    remove_email(index) {
      let emails = [...this.alert_emails];
      emails.splice(index, 1);
      this.save_config(emails);
    },
    is_valid_email(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !email || emailRegex.test(email) || this.$filters.capitalize(this.$t('alertEmailInvalid'));
    },
    save_config(emails) {
      this.loadingDialog = true;
      BotService.updateAlertEmails(this.$route.params.botCode, emails)
        .then(() => {
          this.$AppService.toastSuccess(this.$filters.capitalize(this.$t('alertEmailSuccess')));
          this.setBotConfig({livesupport_alert_emails: emails});
        })
        .catch((e) => {
          consoleError(e);
          this.$AppService.toastError(this.$filters.capitalize(this.$t('alertEmailFail')));
        })
        .finally(() => {
          this.loadingDialog = false;
        })
    }
  }
}
</script>
